import { jsx as _jsx } from "react/jsx-runtime";
export function BackgroundVideo({ src }) {
    return (_jsx("video", { autoPlay: true, loop: true, muted: true, playsInline: true, className: "pointer-events-none fixed inset-0 w-full h-full object-cover z-0 hero", children: _jsx("source", { src: src, type: "video/mp4" }) }));
}
